<template>
  <div class="form_item">
    <div>
      <Label :required="required" :label="label" :for_id="save_to"/>
      <div class="upload-btn-wrapper">
        <button class="upload-btn" type="button"  v-html="buttonUploadLabel" v-if="isButtonUpload"></button>
        <input
          v-validate=""
          :id="save_to"
          type="file"
          :name="validationLabel || label"
          :key="save_to"
          :ref="save_to"
          v-on:change="handleFileUpload()"
          :required="required"
          :autocomplete="autocomplete"
          :class="{'has-error': errors.has(label)}"
          :accept="accept"
        />
      </div>
      <span class="upload-btn-set" v-if="isButtonUpload && $refs[save_to] && $refs[save_to].files && $refs[save_to].files[0]">{{$refs[save_to].files[0].name}}</span>
    </div>
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span class="error" v-show="errors.has(label)">{{ errors.first(label) }}</span>
  </div>
</template>

<script>
import { validatorComponent } from './validatorComponentMixin';

export default {
  name: 'Input',
  mixins: [validatorComponent],
  props: {
    save_to: String,
    type: String,
    isButtonUpload: Boolean,
    buttonUploadLabel: String,
    validationLabel: String,
    sizeMax: {
      type: Number,
      default: 2560
    },
    accept: {
      type: String,
      //required: true
    },
    required: Boolean,
    validationRules: [String, Object],
    autocomplete: String,
    inputmode: {
      type: String,
      default: 'text'
    },
    pattern: String
  },
  computed: {
    rules () {
      if(this.require) {
        return 'required|size:' + this.sizeMax;
      }
      return 'size:' + this.sizeMax;
    }
  },
  methods: {
    handleFileUpload () {
      const file = this.$refs[this.save_to].files[0];
      if (file !== 'undefined') {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = async () => {
          this.val = reader.result;
        };
      }
    }
  }
};
</script>
